/*
  •	Copyright (c) 2023 Pegasystems Inc.
  •	All rights reserved.
*/
import * as StateManager from '../../../store/state/state-manager';
import { listAction } from '../../../store/state/actions/action-creators';
import Utils from '../../../utils/utils';

class DeleteAll {
  static getDeleteAllInstruction(pageReference: string, target: string) {
    return {
      instruction: 'DELETE ALL',
      target: Utils.buildInstructionPageReference(pageReference, target)
    };
  }

  static execute(contextName: string, target: string, pageReference: string, skipStateUpdate: boolean) {
    if (!skipStateUpdate) {
      StateManager.dispatch(
        listAction({
          instruction: 'DESELECT_ALL',
          context: contextName,
          referenceList: `${pageReference}${target}`
        })
      );
    }
  }
}
export default DeleteAll;
